$(function() {
  $('.list-carousel').slick({
    variableWidth: true,
    infinite: false,
    arrows: true
  });
});
